import React from "react";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import NurturingApproachFormContent from "Components/NurturingApproach/NurturingApproachFormContent";
import NurturingApproachInfoContent from "Components/NurturingApproach/NurturingApproachInfoContent";
import { nurturingApproachData, getPageNumber } from "Data";

const NurturingApproachPage = () => {
  const { currentPageData, setSubmitted } = usePageContextUpdate();

  const {
    updateNurturingApproach,
    currentFormData: { nurturingApproach },
  } = useFormData();

  const { updateSession, sessionData } = useSession();

  const handleSubmit = async (selectedValue) => {
    const selectedOption = nurturingApproachData.find(
      (opt) => opt.value === selectedValue,
    );
    const level = selectedOption?.level || 0;

    updateNurturingApproach(selectedValue);

    await updateSession({
      current_page: getPageNumber("marketing-staffing"),
      responses: {
        ...sessionData?.responses,
        q5_nurturing: {
          approach: selectedValue,
          level,
        },
      },
    });

    setSubmitted(true);
  };

  return (
    <FormContentWrapper
      infoContent={
        <NurturingApproachInfoContent heading={currentPageData.pageTitle} />
      }
      formFieldContent={
        <NurturingApproachFormContent
          submitCB={handleSubmit}
          defaultValue={nurturingApproach}
        />
      }
    />
  );
};

export default NurturingApproachPage;
